export const UPDATE_STATS = 'SM UPDATE STATS';
export const SET_OPTIONS = 'SM SET OPTIONS';
export const SELECT_SIZE = 'SM SELECT SIZE';
export const UPDATE_STEPS = 'SM UPDATE STEPS';
export const SET_BLOCK = 'SM SET BLOCK';
export const SET_OVER = 'SM SET OVER';
export const SET_CELLS = 'SM SET CELLS';
export const SET_STEPS = 'SM SET STEPS';
export const SET_INIT = 'SM SET INIT';
export const SET_SWAP_DURATION = 'SM SET SWAP DURATION';

export const updateStats = stats => ({ type: UPDATE_STATS, stats });
export const setOptions = options => ({ type: SET_OPTIONS, options });
export const selectSize = size => ({ type: SELECT_SIZE, size });
export const updateSteps = update => ({ type: UPDATE_STEPS, update });
export const setBlock = on => ({ type: SET_BLOCK, blocked: on });
export const setOver = on => ({ type: SET_OVER, over: on });
export const setCells = cells => ({ type: SET_CELLS, cells });
export const setSteps = steps => ({ type: SET_STEPS, steps });
export const setInit = on => ({ type: SET_INIT, init: on });
export const setSwapDuration = ms => ({ type: SET_SWAP_DURATION, swapDuration: ms });
